document.addEventListener('DOMContentLoaded', function () {
    const sliders = document.querySelectorAll('.textslider-container');

    sliders.forEach(sliderContainer => {
        const slidesContainer = sliderContainer.querySelector('.textslider-slides');
        const slides = sliderContainer.querySelectorAll('.textslider-slide');
        const dots = sliderContainer.querySelectorAll('.textslider-dot');
        const prevButton = sliderContainer.querySelector('.textslider-arrow-prev');
        const nextButton = sliderContainer.querySelector('.textslider-arrow-next');

	        if (!slidesContainer || slides.length === 0) return;
	
	        let currentSlide = 0;
	        let touchStartX = 0;
	        let touchStartY = 0;

        function goToSlide(index) {
            if (index < 0) {
                currentSlide = slides.length - 1;
            } else if (index >= slides.length) {
                currentSlide = 0;
            } else {
                currentSlide = index;
            }

            const offset = -currentSlide * 100;
            slidesContainer.style.transform = `translateX(${offset}%)`;

            dots.forEach((dot, i) => {
                if (i === currentSlide) {
                    dot.classList.add('active');
                } else {
                    dot.classList.remove('active');
                }
            });
        }

        dots.forEach((dot, index) => {
            dot.addEventListener('click', () => {
                goToSlide(index);
            });
        });

        if (prevButton) {
            prevButton.addEventListener('click', () => {
                goToSlide(currentSlide - 1);
            });
        }

	        if (nextButton) {
	            nextButton.addEventListener('click', () => {
	                goToSlide(currentSlide + 1);
	            });
	        }

	        sliderContainer.addEventListener('touchstart', (event) => {
	            if (window.innerWidth > 768 || event.touches.length !== 1) return;

	            touchStartX = event.touches[0].clientX;
	            touchStartY = event.touches[0].clientY;
	        }, { passive: true });

	        sliderContainer.addEventListener('touchend', (event) => {
	            if (window.innerWidth > 768 || !touchStartX) return;

	            const touch = event.changedTouches[0];
	            const deltaX = touch.clientX - touchStartX;
	            const deltaY = touch.clientY - touchStartY;
	            touchStartX = 0;
	            touchStartY = 0;

	            if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;

	            goToSlide(currentSlide + (deltaX < 0 ? 1 : -1));
	        }, { passive: true });
	    });
	});
